'use client';

import { c as _c } from "react/compiler-runtime";
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { type FC } from 'react';
import { SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from '@/app/theme';
import { UserMenu } from '@/app/_components/UserMenu';
import { SuggestionButton } from '@/app/_components/SuggestionButton';
import Image from 'next/image';
import optLogoUrl from '@/public/OPT-long.png';
import qmtLogoUrl from '@/public/QMT-long.png';
import Box from '@mui/material/Box';
import { RoleSwitcher } from '@/app/_components/RoleSwitcher';
import { usePathname } from 'next/navigation';
const optRoutes = ['/quotes'];
interface TopBarProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
  env: 'development' | 'production' | 'test';
  currentRole?: string;
  jmtAccess?: boolean;
  qmtAccess?: boolean;
}
export const TopBar: FC<TopBarProps> = t0 => {
  const $ = _c(30);
  const {
    isMenuOpen,
    onToggleMenu,
    env,
    currentRole: t1,
    jmtAccess: t2,
    qmtAccess: t3
  } = t0;
  const currentRole = t1 === undefined ? "USER" : t1;
  const jmtAccess = t2 === undefined ? true : t2;
  const qmtAccess = t3 === undefined ? false : t3;
  const path = usePathname();
  const useOPTLogo = optRoutes.some(route => path.startsWith(route));
  const logoUrl = useOPTLogo ? optLogoUrl : qmtLogoUrl;
  const logoAlt = useOPTLogo ? "OPT" : "QMT";
  let t4;
  if ($[0] !== isMenuOpen) {
    t4 = theme => ({
      backgroundColor: theme.palette.getContrastText(theme.palette.primary.main),
      height: TOP_BAR_HEIGHT,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      ...(isMenuOpen && {
        marginLeft: SIDEBAR_WIDTH,
        width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      })
    });
    $[0] = isMenuOpen;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      justifyContent: "space-between"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== isMenuOpen) {
    t6 = isMenuOpen && {
      display: "none"
    };
    $[3] = isMenuOpen;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t6) {
    t7 = {
      marginRight: 5,
      ...t6
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MenuIcon />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== onToggleMenu || $[9] !== t7) {
    t9 = <IconButton color="primary" onClick={onToggleMenu} edge="start" sx={t7}>{t8}</IconButton>;
    $[8] = onToggleMenu;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== currentRole || $[12] !== env || $[13] !== jmtAccess || $[14] !== qmtAccess) {
    t10 = env !== "production" && <RoleSwitcher currentRole={currentRole} env={env} jmtAccess={jmtAccess} qmtAccess={qmtAccess} />;
    $[11] = currentRole;
    $[12] = env;
    $[13] = jmtAccess;
    $[14] = qmtAccess;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      flexGrow: 1,
      aspectRatio: "auto",
      width: 650,
      height: 65
    };
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== logoAlt || $[18] !== logoUrl) {
    t12 = <Image src={logoUrl} priority={true} height={65} width={650} alt={logoAlt} style={t11} />;
    $[17] = logoAlt;
    $[18] = logoUrl;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t12) {
    t13 = <Box display="inline-flex" alignItems="center" gap={2}>{t10}{t12}</Box>;
    $[20] = t10;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Box display="inline-flex" alignItems="center" gap={1}><SuggestionButton /><UserMenu /></Box>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13 || $[25] !== t9) {
    t15 = <Toolbar sx={t5}>{t9}{t13}{t14}</Toolbar>;
    $[24] = t13;
    $[25] = t9;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== t4) {
    t16 = <AppBar sx={t4}>{t15}</AppBar>;
    $[27] = t15;
    $[28] = t4;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};